export default __webpack_public_path__ + "static/media/assetCalendar.47be2ac4.svg";